import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Table, Data } from 'components/layout/Table'
import { labels as labelsLayout } from 'constants/layout'
import get from 'lodash/get'
import { Modal } from '../../../../containers/misc'
import { LabelRemove, LabelUpdate } from '../../../../containers/forms/labels'
import { Button, ButtonGroup, Status } from '../../../misc'
import { FormattedMessage } from 'react-intl'


export default class LabelsTable extends PureComponent {
  static propTypes = {
    labels: PropTypes.object.isRequired,
    showOrgDetail: PropTypes.bool.isRequired,
    modal: PropTypes.func.isRequired,
    onDeleteLabel: PropTypes.func.isRequired,
    hideAction: PropTypes.bool.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    setParams: PropTypes.func
  }

  state = {
     id: null,
     label: null
  }

  static defaultProps = {
    permissions: {}
  }

  getLabels = labels => {
    const labelsCompList = []

    labels.forEach(l => {
    labelsCompList.push(
        <div style={{
          float: 'left',
          backgroundColor: '#dbdbdb',
          padding: '2px',
          margin: '3px 3px 3px 0px',
          borderRadius: '3px',
          fontSize: '0.8em',
          color: '#4e4e4e',
          fontWeight: '700'
        }}>
        {get(l, 'label.name')}
        </div>
    )
    })
    return labelsCompList
  }
    handleDeleteLabel = id => {
        this.setState({ id },
            () => {
                this.props.modal('label-remove-modal')
            }
        )
    }

    handleEditLabel = label => {
        this.setState({ label },
            () => {
                this.props.modal('modal-update-label')
            }
        )
    }


    render() {
      const {
          labels: { loading, list, offset, limit, pages, sort },
          setParams,
          showOrgDetail,
          onDeleteLabel,
          hideAction
      } = this.props

    return (
      <div>
          <Table
              loading={loading}
              length={list.length}
              offset={offset}
              limit={limit}
              pages={pages}
              sort={sort}
              ths={showOrgDetail ? labelsLayout.tableHeadersChildOrgLabels : (hideAction ? labelsLayout.tableHeadersWithoutAction : labelsLayout.tableHeaders)}
              setParams={setParams}
          >
              <Data>
                  {list.map(label => (

                      <tr key={get(label, 'id')}>
                          <td>
                              {get(label, 'id')}
                          </td>
                          <td>
                              {get(label, 'name')}
                          </td>
                          <td>
                              {get(label, 'description')}
                          </td>
                          <td>
                              {get(label, 'category.translationText')}
                          </td>
                        <td>
                          <Status
                            state={Boolean(get(label, 'isReserved'))}
                            check
                            inline
                            noWaiting
                          />
                        </td>
                          {showOrgDetail && <td>
                              {get(label, 'organization.name')}
                          </td>}

                          {showOrgDetail && <td>
                              {get(label, 'organization.hierarchyLevel.value')}
                          </td>}

                          {!showOrgDetail && !hideAction && <td>

                              <ButtonGroup>
                                  <Button
                                      type="button"
                                      intlKey="button.edit"
                                      onClick={() => this.handleEditLabel(label)}
                                      tiny
                                  >
                                      Edit
                                  </Button>
                                  <Button
                                      onClick={() => this.handleDeleteLabel(get(label, 'id'))}
                                      tiny
                                      intlKey="button.delete"
                                      secondary
                                  >
                                      Delete
                                  </Button>
                              </ButtonGroup>
                          </td>}

                      </tr>
                  ))}
              </Data>
          </Table>
          <Modal id="label-remove-modal" customActions enableOverflow>
              <LabelRemove
                  id={this.state.id}
                  onDeleteLabel={onDeleteLabel}
              />
          </Modal>
          <Modal id="modal-update-label" customActions fluid>
              <LabelUpdate data={this.state.label} onClose={() => this.props.modal(null)} />
          </Modal>
      </div>
    )
  }
}
